import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { style: {"width":"5px","white-space":"nowrap"} }, null, -1)
const _hoisted_2 = { style: {"margin-left":"2px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_v_nodes = _resolveComponent("v-nodes")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    disabled: _ctx.disabled,
    multiple: false,
    placeholder: _ctx.placeholder,
    value: _ctx.value,
    "allow-clear": "",
    "option-filter-prop": "title",
    "show-search": "",
    virtual: false,
    onChange: _ctx.onChange
  }, _createSlots({
    default: _withCtx(() => [
      (_ctx.hideDisabled)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.recordsHandled, (item) => {
            return (_openBlock(), _createBlock(_component_a_select_option, {
              key: item.id,
              title: item.name,
              value: item.id
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["title", "value"]))
          }), 128))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.records, (item) => {
            return (_openBlock(), _createBlock(_component_a_select_option, {
              disabled: _ctx.isDisabled(item.code),
              key: item.id,
              title: item.name,
              value: item.id
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["disabled", "title", "value"]))
          }), 128))
    ]),
    _: 2
  }, [
    (_ctx.addText)
      ? {
          name: "dropdownRender",
          fn: _withCtx(({ menuNode: menu }) => [
            _createVNode(_component_v_nodes, { vnodes: menu }, null, 8, ["vnodes"]),
            _createVNode(_component_a_divider, { style: {"margin":"4px 0"} }),
            _createElementVNode("div", {
              style: {"padding":"4px 12px","cursor":"pointer"},
              onMousedown: _cache[1] || (_cache[1] = (e) => e.preventDefault())
            }, [
              _createVNode(_component_router_link, { to: "/material/accessManagement/list" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "ub ub-ac ub-ps",
                    style: {"color":"#333"},
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toAddInStorageType && _ctx.toAddInStorageType(...args)))
                  }, [
                    _createVNode(_component_plus_outlined),
                    _hoisted_1,
                    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.addText), 1)
                  ])
                ]),
                _: 1
              })
            ], 32)
          ])
        }
      : undefined
  ]), 1032, ["disabled", "placeholder", "value", "onChange"]))
}